import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { faPenToSquare, faFolderPlus, faX, faTrash, faFloppyDisk, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ModalKnowledgeSkeleton from "../../Skeleton/modalUpdatedKnowledge/modalKnowledgeSkeleton";
import { KnowledgeSpecializationItem, LevelTier } from "../../../Interfaces/KnowledgeSpecialization";

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SOURCE_VALIDATED = 2;

// Mejoras Chambaticon §B.2: técnica/blanda/sin clasificar, en ese orden — "Otras
// competencias" (sin clasificar) siempre al final, nunca escondida (§B.2).
const COMPETENCY_TYPE_SECTIONS: { type: number | null; title: string }[] = [
   { type: 1, title: 'Competencias técnicas' },
   { type: 2, title: 'Competencias blandas' },
   { type: null, title: 'Otras competencias' },
];

// Mejoras Chambaticon §B.2: indicador discreto de 4 segmentos, en vez de la barra de
// porcentaje — corrige que una validada de nivel bajo se viera llena al 100% (§CB.2).
const LevelSegments = ({ tier }: { tier: number | null }) => (
   <div className="flex gap-1 mt-2" role="img" aria-label={`Nivel ${tier ?? 0} de 4`}>
      {[1, 2, 3, 4].map((segment) => (
         <div
            key={segment}
            className={`h-2 flex-1 rounded ${tier && segment <= tier ? 'bg-Light-Blue' : 'bg-white/20'}`}
         ></div>
      ))}
   </div>
);

const MESES_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

const formatEvaluationDate = (isoDate: string): string => {
   const parsed = new Date(isoDate);
   if (isNaN(parsed.getTime())) return '';
   return `${MESES_ES[parsed.getMonth()]} ${parsed.getFullYear()}`;
};


interface Props {
   animation: string;
   state: String
   idFreeRouter: String | undefined;
}

const initialStateknowledge: KnowledgeSpecializationItem = {
   id: 0,
   K_specialization_id: 0,
   name: "",
   specialization_category: "",
   knowledge_level: 0,
   level_tier: null,
   level_tier_label: null,
   competency_type: null,
   competency_type_label: null,
   source: 1,
   is_editable: 1,
   validated_at: null,
   measurements: []
}

const initialStateListSpecialization = {
   created_at: "",
   id: 0,
   name: "",
   updated_at: ""
}


const Specialization = ({ animation, idFreeRouter, state }: Props) => {

   // Cookies
   const cookies = new Cookies();

   const getSesion = cookies.get("Bearer") || {};

   const [specializations, setSpecializations] = useState([initialStateListSpecialization]);

   const [knowledge, setknowledge] = useState<KnowledgeSpecializationItem[]>([initialStateknowledge]);

   const [indoModalKnowledge, setIndoModalKnowledge] = useState({ id: 0, name: "", level_tier: 0, idCo: 0 });

   const [levelTiers, setLevelTiers] = useState<LevelTier[]>([]);

   const [IsLoading, setIsLoading] = useState(true);

   const [hasError, setHasError] = useState(false);

   const [IsLoadingModal, setIsLoadingModal] = useState(true);

   const MySwal = withReactContent(Swal);

   const [toggleShowAndHide, setToggleShowAndHide] = useState<Boolean>(false);

   const [addClass, setAddClass] = useState<string>("hidden bg-fadeOut");

   const [idUser, setidUser] = useState<number>(0);

   const validatedKnowledge = knowledge.filter((item) => item.name != "" && (Number(item.source) === SOURCE_VALIDATED));

   const selfDeclaredKnowledge = knowledge.filter((item) => item.name != "" && (Number(item.source) !== SOURCE_VALIDATED));

   // Mejoras Chambaticon §B.2: agrupa un subconjunto cualquiera de autodeclaradas por área
   // temática (specialization_category) — antes era un cómputo fijo sobre todas las
   // autodeclaradas; ahora se reusa una vez por sección técnica/blanda/sin clasificar.
   const buildCategoryGroups = (items: KnowledgeSpecializationItem[]) => {
      if (items.length === 0) return [];

      const groups = specializations
         .map((specialization) => ({
            name: specialization.name,
            list: items.filter((knowledgeFree) => knowledgeFree.specialization_category === specialization.name),
         }))
         .filter((group) => group.list.length > 0);

      return groups;
   };

   const bySelfDeclaredType = (type: number | null) => selfDeclaredKnowledge.filter((item) => item.competency_type === type);
   const byValidatedType = (type: number | null) => validatedKnowledge.filter((item) => item.competency_type === type);
   async function fetchData() {

      const { id } = cookies.get('Bearer') || {};

      let urlCountry = "";

      if (state == "Public") {

         urlCountry = `${process.env.REACT_APP_API_URI}freelancer/list/knowledge-specializations/${idFreeRouter}`;

      } else if (state == "session") {

         urlCountry = `${process.env.REACT_APP_API_URI}freelancer/list/knowledge-specializations/${id}`;

      };

      let config = {
         headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'ApiToken': `Bearer ${getSesion.token}`
         }
      };

      try {

         const resp = await axios.get(urlCountry, config);
         // // console.log("resp ==>", resp);
         const specializationFreelancer = resp.data.data;

         setknowledge(specializationFreelancer);

         setHasError(false);

         setIsLoading(false)

      } catch (err: any) {
         // Handle Error Here
         setIsLoading(false);
         if (err?.response?.status !== 404) {
            setHasError(true);
         }
         console.error(err);
      }
   };

   useEffect(() => {

      fetchData();

      async function getSpecialties() {

         const urlCountry = `${process.env.REACT_APP_API_URI}Knowledge-specialization/list/types`;

         let config = {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json',
            }
         };
         try {

            const resp = await axios.get(urlCountry, config);
            setSpecializations(resp.data.specializationTypes);

            // setIsLoading(false);

         } catch (err) {
            // Handle Error Here
            setIsLoading(false);
            console.error(err);
         }
      };
      getSpecialties();

      async function getLevelTiers() {
         try {
            const resp = await axios.get(`${process.env.REACT_APP_API_URI}Knowledge-specialization/list/levels`);
            setLevelTiers(resp.data.data);
         } catch (err) {
            console.error(err);
         }
      };
      getLevelTiers();

      const getIdUser = () => {
         const { id } = cookies.get('Bearer') || {};
         setidUser(id)
      }
      getIdUser();

   }, []);


   const handleModal = () => {
      toggleShowAndHide ? setToggleShowAndHide(false) : setToggleShowAndHide(true);

      if (!toggleShowAndHide) {
         setAddClass("block bg-fadeIn");
      } else {
         setAddClass("bg-fadeOut");
         setTimeout(() => { setAddClass("hidden") }, 500);
      }
   }

   const resetInfo = () => {
      handleModal();
      setIndoModalKnowledge({ id: 0, name: "", level_tier: 0, idCo: 0 });
      setknowledge([initialStateknowledge]);
      fetchData();
   };

   const showModal = (name: string, levelTier: number, knowledge: number, id_registro: number) => {

      setIndoModalKnowledge({ id: id_registro, name: "", level_tier: 0, idCo: knowledge });

      handleModal();

      setIndoModalKnowledge({ id: id_registro, name: name, level_tier: levelTier, idCo: knowledge });

      setTimeout(() => { setIsLoadingModal(false) }, 1000);

   };

   const closeModalKnowledge = () => {

      toggleShowAndHide ? setToggleShowAndHide(false) : setToggleShowAndHide(true);

      if (!toggleShowAndHide) {
         setAddClass("block bg-fadeIn");
      } else {
         setAddClass("bg-fadeOut");
         setTimeout(() => { setAddClass("hidden") }, 500);
      };

      setIsLoadingModal(true);
   };


   // Mejoras Chambaticon §B.1/§B.2: 4 niveles con etiqueta en vez de un slider de porcentaje.
   const handleTierSelect = (levelTier: number) => {
      setIndoModalKnowledge({ ...indoModalKnowledge, level_tier: levelTier });
   };

   const deleteKnowledge = async () => {

      // console.log('knowledge.id', indoModalKnowledge.id);
      const urlDeleteKnowledge = `${process.env.REACT_APP_API_URI}freelancer/delete/Knowledge-specializations/${indoModalKnowledge.id}`;

      let config = {
         headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'ApiToken': `Bearer ${getSesion.token}`
         }
      };

      axios.delete(urlDeleteKnowledge, config)
         .then(response => {
            // console.log(response);
            MySwal.fire({
               position: 'center',
               icon: 'success',
               title: response.data.message,
               showConfirmButton: false,
               timer: 3500
            });

            resetInfo();

         }).catch(err => {

            // console.log(err)
            MySwal.fire({
               position: 'center',
               icon: 'error',
               title: err.response?.status === 403
                  ? 'Esta competencia fue validada por una evaluación y no puede modificarse.'
                  : (err.response?.data?.message || 'No se pudo eliminar la competencia.'),
               showConfirmButton: false,
               timer: 3500
            });

            if (err.response?.status === 403) {
               resetInfo();
            }

         });


   };

   const updatedKnowledge = async () => {

      if (!indoModalKnowledge.level_tier) {
         MySwal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Elige un nivel',
            showConfirmButton: false,
            timer: 3500
         });
         return;
      }

      const url = `${process.env.REACT_APP_API_URI}freelancer/register/Knowledge-specializations`;

      let config = {
         headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'ApiToken': `Bearer ${getSesion.token}`
         }
      };

      const knowledges = {
         'user_id': idUser,
         'knowledges': [{
            knowledge_id: indoModalKnowledge.idCo,
            level_tier: indoModalKnowledge.level_tier
         }]

      };

      axios.post(url, knowledges, config)
         .then(response => {
      
            MySwal.fire({
               position: 'center',
               icon: 'success',
               title: response.data.message,
               showConfirmButton: false,
               timer: 3500
            });

            resetInfo();

         })
         .catch(err => {
            MySwal.fire({
               position: 'center',
               icon: 'error',
               title: err.response?.status === 403
                  ? 'Esta competencia fue validada por una evaluación y no puede modificarse.'
                  : (err.response?.data?.message || 'No se pudo actualizar la competencia.'),
               showConfirmButton: false,
               timer: 3500
            });

            if (err.response?.status === 403) {
               resetInfo();
            }
         })

   };

   // Mejoras Chambaticon §CB.2: corrige que una competencia validada de nivel bajo se viera
   // llena al 100% — ahora muestra su nivel real (LevelSegments) y la insignia "Validado"
   // por separado (son dos cosas distintas: el nivel dice cuánto, el candado dice quién lo
   // respalda). Extraído a función porque ahora se llama una vez por sección técnica/blanda.
   const renderValidatedCard = (item: KnowledgeSpecializationItem, key: number) => {
      const sortedMeasurements = [...(item.measurements || [])].sort(
         (a, b) => new Date(a.evaluated_at).getTime() - new Date(b.evaluated_at).getTime()
      );
      const latestMeasurement = sortedMeasurements.length > 0
         ? sortedMeasurements[sortedMeasurements.length - 1]
         : null;
      const latestLabel = latestMeasurement
         ? (latestMeasurement.level_label || '').replace(/^nivel\s+/i, '')
         : '';
      const latestScoreRaw = latestMeasurement ? parseFloat(latestMeasurement.score) : NaN;
      const latestScore = !isNaN(latestScoreRaw) ? Math.max(0, Math.min(100, latestScoreRaw)) : null;

      return (
         <div key={key} className="mt-4 w-full sm:w-1/2 p-6 relative">
            <div className="text-start float-left">
               {item.name}{' '}
               <FontAwesomeIcon icon={faLock} className="text-Yellow text-xs" title="Validado" />
            </div>
            <div className="text-end">
               {state == "session" ? (item.level_tier_label || 'Sin nivel') : 'Validado'}
            </div>
            <div className="clear-both">
               <LevelSegments tier={item.level_tier} />
            </div>

            {state == "session" && sortedMeasurements.length > 0 && (
               <div className="mt-3 space-y-2">
                  {sortedMeasurements.map((m, mi) => {
                     const scoreValue = Math.max(0, Math.min(100, parseFloat(m.score) || 0));
                     return (
                        <div key={mi} className="text-xs text-gray-200">
                           <div className="flex justify-between mb-1">
                              <span>{formatEvaluationDate(m.evaluated_at)}</span>
                              <span>{Math.round(scoreValue)}%</span>
                           </div>
                           <div className="shadow w-full bg-white rounded-lg">
                              <div className="bg-Light-Blue text-[10px] py-0.5 text-center text-white rounded-lg" style={{ width: `${scoreValue}%`, lineHeight: '0' }}></div>
                           </div>
                        </div>
                     );
                  })}
               </div>
            )}

            {state != "session" && (latestLabel || latestScore !== null) && (
               <p className="text-xs text-gray-300 mt-2">
                  {latestLabel && `Nivel: ${latestLabel}`}
                  {latestLabel && latestScore !== null && ' · '}
                  {latestScore !== null && `${Math.round(latestScore)}%`}
               </p>
            )}
         </div>
      );
   };

   const renderSelfDeclaredCard = (knowledgeFreelancer: KnowledgeSpecializationItem, key: number) => (
      <div key={key} className="mt-4 w-full sm:w-1/2 p-6 relative">
         <div className="text-start float-left">{knowledgeFreelancer.name}</div>
         <div className="text-end">{knowledgeFreelancer.level_tier_label || 'Sin nivel'}</div>
         <div className="clear-both">
            <LevelSegments tier={knowledgeFreelancer.level_tier} />
         </div>

         {(state == "session") && (
            <div className="inline-block p-1 bg-Yellow text-white font-medium text-xs leading-tight uppercase shadow-md hover:bg-amber-500 hover:shadow-lg focus:bg-amber-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-amber-600 active:shadow-lg transition duration-150 ease-in-out absolute top-0 right-0 rounded-lg cursor-pointer">
               <FontAwesomeIcon
                  onClick={() => showModal(knowledgeFreelancer.name, knowledgeFreelancer.level_tier || 0, knowledgeFreelancer.K_specialization_id, knowledgeFreelancer.id)}
                  className="text-white text-lg"
                  icon={faPenToSquare}
               />
            </div>
         )}
      </div>
   );

   return (
      <>
         <div className={`text-white ${animation}`} id="contenedorEspecializacionProfesional" role="tabpanel" aria-labelledby="profile-tab">

            {
               (state == "session") &&
               <div className="w-full text-center">
                  <Link
                     to="/registrar-habilidades"
                     className="mb-4 inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                     Agregar
                     {/* <FontAwesomeIcon className="text-white text-lg px-2" icon={faFolderPlus} /> */}
                  </Link>
               </div>
            }

            {IsLoading && (
               <div className="border border-Light-Blue p-5 mb-5 rounded-lg">
                  <h2 className="text-start"><Skeleton count={1} width={200} /></h2>
                  <div className="flex flex-wrap">
                     <div className="mt-4 w-full sm:w-1/2 p-5 relative">
                        <div className="text-start float-left"><Skeleton count={1} width={150} /></div>
                        <div className="text-end"><Skeleton count={1} width={150} /></div>
                        <Skeleton count={1} />
                     </div>
                     <div className="mt-4 w-full sm:w-1/2 p-5 relative">
                        <div className="text-start float-left"><Skeleton count={1} width={150} /></div>
                        <div className="text-end"><Skeleton count={1} width={150} /></div>
                        <Skeleton count={1} />
                     </div>
                     <div className="mt-4 w-full sm:w-1/2 p-5 relative">
                        <div className="text-start float-left"><Skeleton count={1} width={150} /></div>
                        <div className="text-end"><Skeleton count={1} width={150} /></div>
                        <Skeleton count={1} />
                     </div>
                     <div className="mt-4 w-full sm:w-1/2 p-5 relative">
                        <div className="text-start float-left"><Skeleton count={1} width={150} /></div>
                        <div className="text-end"><Skeleton count={1} width={150} /></div>
                        <Skeleton count={1} />
                     </div>
                  </div>
               </div>
            )}

            {/* Mejoras Chambaticon §B.2: técnicas / blandas / sin clasificar, en ese orden.
                Una sección no se muestra si el talento no tiene nada de ese tipo (§B.2). */}
            {!IsLoading && COMPETENCY_TYPE_SECTIONS.map(({ type, title }) => {
               const validatedItems = byValidatedType(type);
               const selfDeclaredItems = bySelfDeclaredType(type);
               const selfDeclaredGroups = buildCategoryGroups(selfDeclaredItems);

               if (validatedItems.length === 0 && selfDeclaredItems.length === 0) {
                  return null;
               }

               return (
                  <div key={String(type)} className="mb-6">
                     <h2 className="text-start text-Yellow text-lg font-bold mb-2">{title}</h2>

                     {validatedItems.length > 0 && (
                        <div className="border border-Light-Blue p-5 mb-5 rounded-lg">
                           <h3 className="text-start">
                              <FontAwesomeIcon icon={faLock} className="text-Yellow mr-2" />
                              Competencias validadas
                           </h3>
                           {state == "session" && (
                              <p className="text-xs text-gray-300 italic mt-1 mb-2">
                                 Estas competencias provienen de una evaluación externa y no pueden modificarse.
                              </p>
                           )}
                           <div className="flex flex-wrap">
                              {validatedItems.map((item, key) => renderValidatedCard(item, key))}
                           </div>
                           {state != "session" && (
                              <p className="text-[11px] text-gray-400 italic mt-4 border-t border-Light-Blue pt-3">
                                 Las competencias validadas provienen de evaluaciones aplicadas por CONEXIÓN.
                              </p>
                           )}
                        </div>
                     )}

                     {selfDeclaredItems.length > 0 && (
                        <>
                           {state == "session" && (
                              <h3 className="text-start text-white mb-2">Competencias que agregaste</h3>
                           )}
                           {selfDeclaredGroups.map((group, key) => (
                              <div key={key} className="border border-Light-Blue p-5 mb-5 rounded-lg">
                                 <h3 className="text-start">{group.name}</h3>
                                 <div className="flex flex-wrap">
                                    {group.list.map((knowledgeFreelancer, key2) => renderSelfDeclaredCard(knowledgeFreelancer, key2))}
                                 </div>
                              </div>
                           ))}
                        </>
                     )}
                  </div>
               );
            })}

            {!IsLoading && validatedKnowledge.length === 0 && selfDeclaredKnowledge.length === 0 && (
               <p className="text-center mt-9">
                  {hasError
                     ? 'No se pudieron cargar las especializaciones. Intenta de nuevo más tarde.'
                     : 'No se encontraron especializaciones'}
               </p>
            )}
         </div>
         <div id="modal-component-container" className={`fixed inset-0  hidden-modal ${toggleShowAndHide ? addClass : addClass}`}>
            <div className="modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-96 text-center sm:block sm:pb-0 ">

               <div className='modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75'></div>
               <div className='modal-space-container hidden h-80 sm:inline-block sm:align-middle'> &nbsp;</div>

               <div className={`modal-container inline-block align-bottom bg-turquoise rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:aling-middle sm:w-2/4 w-full ${toggleShowAndHide ? 'modal-scaleIn' : 'modal-scaleout '}`}>


                  {IsLoadingModal &&
                     <ModalKnowledgeSkeleton />
                  }

                  {!IsLoadingModal &&
                     <>
                        <div className='modal-wrapper bg-stable-background-modal px-4 pt-5 pb-4 sm:p-6 sm:pb-4 relative'>
                           <h1 className="text-center text-2xl text-Yellow font-bold">Editar especialidad</h1>
                           <div className="modal-wrapper-flex">
                              <div className="px-8 grid py-4 w-full">
                                 <label htmlFor="" className="text-white h-12 overflow-hidden">{indoModalKnowledge.name}</label>
                                 <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-2">
                                    {levelTiers.map((lvl) => (
                                       <button
                                          type="button"
                                          key={lvl.level_tier}
                                          onClick={() => handleTierSelect(lvl.level_tier)}
                                          className={`px-2 py-2 rounded-lg text-sm font-medium border transition duration-150 ease-in-out ${indoModalKnowledge.level_tier === lvl.level_tier
                                             ? 'bg-Yellow text-white border-Yellow'
                                             : 'bg-transparent text-white border-gray-400 hover:border-Yellow'
                                             }`}
                                       >
                                          {lvl.label}
                                       </button>
                                    ))}
                                 </div>
                                 {indoModalKnowledge.level_tier > 0 && (
                                    <p className="text-xs text-gray-300 italic mt-2">
                                       {levelTiers.find((lvl) => lvl.level_tier === indoModalKnowledge.level_tier)?.description}
                                    </p>
                                 )}
                              </div>
                           </div>
                        </div>

                        <div className='modal-actions bg-stable-background-modal px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'>

                           <div className="mb-4 absolute top-2 right-2">
                              <button className="w-full inline-flex justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-Light-Blue text-white font-mediumtext-gray-700 hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                 onClick={() => closeModalKnowledge()}
                              >
                                 <FontAwesomeIcon icon={faX} />
                              </button>
                           </div>

                           <div className="mb-4">
                              <button
                                 type="submit"
                                 className="w-full inline-flex justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-red-500 text-white font-mediumtext-gray-700hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                 onClick={() => {
                                    MySwal.fire({
                                       title: '¿Estás seguro?',
                                       text: "No podrás revertir esto!",
                                       icon: 'warning',
                                       showCancelButton: true,
                                       confirmButtonColor: '#3085d6',
                                       cancelButtonColor: '#d33',
                                       confirmButtonText: 'Sí, eliminarlo!'
                                    }).then((result) => {
                                       if (result.isConfirmed) {
                                          deleteKnowledge();
                                       }
                                    })
                                 
                                 }}
                              >
                                 {/* <FontAwesomeIcon icon={faTrash} /> */}
                                 Eliminar
                              </button>
                           </div>

                           <div className="mb-4">
                              <button
                                 type="submit" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-md px-4 py-2 bg-Yellow text-white font-mediumtext-gray-700hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                 onClick={() => updatedKnowledge()}
                              >
                                 {/* <FontAwesomeIcon icon={faFloppyDisk} /> */}
                                 Actualizar
                              </button>
                           </div>

                        </div>
                     </>

                  }

               </div>

            </div>

         </div>
      </>
   )
}

export default Specialization;